import loadable from '@loadable/component';

export const OrgDashboardListIntegrationPageLoadable = loadable(
  () => import('./OrgDashboardListIntegrationsPage'),
  { resolveComponent: (module) => module.OrgDashboardListIntegrationsPage },
);
